import AnimatedComponent from '../Components/AnimatedComponent'

function HeroArrowButton({ direction = 'left', onClick, className = '' }) {
    return (
        <button
            type='button'
            onClick={onClick}
            className={`relative z-30 flex h-14 w-14 cursor-pointer items-center justify-center text-text_primary transition-transform duration-200 hover:scale-110 ${className}`}
            aria-label={direction === 'left' ? 'Previous slide' : 'Next slide'}
        >
            <svg
                viewBox='0 0 24 24'
                fill='none'
                stroke='currentColor'
                strokeWidth='1.5'
                className='h-14 w-14'
                aria-hidden='true'
            >
                {direction === 'left' ? (
                    <path strokeLinecap='round' strokeLinejoin='round' d='M15.75 19.5 8.25 12l7.5-7.5' />
                ) : (
                    <path strokeLinecap='round' strokeLinejoin='round' d='m8.25 4.5 7.5 7.5-7.5 7.5' />
                )}
            </svg>
        </button>
    )
}

export default function MainSection({ title, description ,src, onPrevious, onNext }) {

    return (
        <>
            <div className='relative overflow-visible'>
                {(onPrevious || onNext) ? (
                    <div className='pointer-events-none absolute left-0 right-0 top-1/2 z-20 hidden -translate-y-1/2 1.5md:block'>
                        <div className='mx-auto flex w-full max-w-8xl items-center justify-between px-14 1.5xl:px-18'>
                            {onPrevious ? (
                                <HeroArrowButton
                                    direction='left'
                                    onClick={onPrevious}
                                    className='pointer-events-auto -ml-[70px] 1.5xl:-ml-[100px]'
                                />
                            ) : <div />}
                            {onNext ? (
                                <HeroArrowButton
                                    direction='right'
                                    onClick={onNext}
                                    className='pointer-events-auto -mr-[70px] 1.5xl:-mr-[100px]'
                                />
                            ) : <div />}
                        </div>
                    </div>
                ) : null}

                <div className='hidden 1.5xl:block'>
                    <div className='1.5xl:grid 1.5xl:grid-cols-2 1.5xl:gap-5 1.5xl:px-18 1.5xl:py-10'>
                        <AnimatedComponent
                            direction={`animate-slide-left`}
                            className='w-full h-full pe-20'
                        >
                            <div className='flex h-full w-full flex-col justify-center'>
                                <h1 className='mb-6 text-start text-4xl font-bold text-text_primary'>
                                    {title}
                                </h1>
                            <p className='mb-7 max-w-[34rem] text-start text-lg text-text_secondary'>
                                {description}
                            </p>
                            </div>
                        </AnimatedComponent>

                        <AnimatedComponent
                            direction={`animate-slide-right`}
                            className='w-full h-full'
                        >
                            <div className='overflow-visible'>
                                <div className='flex h-full items-center justify-center overflow-visible pe-10'>
                                    <img
                                        className='h-110 object-contain'
                                        src={src}
                                        alt=''
                                    >
                                    </img>
                                </div>
                            </div>
                        </AnimatedComponent>
                    </div>
                </div>

                <div className='relative grid gap-8 md:gap-6 1.5md:grid-cols-[0.62fr_1fr] grid-cols-1 xl:items-center xl:py-8 1.5md:px-14 1.5md:pb-6 1.5md:pt-14 py-0 1.5xl:hidden'>
                    <AnimatedComponent
                        direction={`animate-slide-left`}
                        className={`w-full h-full lg:col-span-1 xl:pe-12 1.5md:pe-6 pe-0 1.5md:order-first order-last`} >
                        <div className='mt-5 flex h-full w-full flex-col justify-center md:mt-0'>
                            <h1 className='text-start font-bold mb-4 text-text_primary text-[23px] leading-[1.15] md:text-[30px] lg:text-[32px]'>
                                {title}
                            </h1>
                            <p className='max-w-[26rem] text-start text-[15px] leading-7 text-text_secondary md:text-[16px] lg:text-[17px]'>
                                {description}
                            </p>
                        </div>
                    </AnimatedComponent>

                    <AnimatedComponent
                        direction={`animate-slide-right`}
                        className={`w-full h-full lg:col-span-1`} >
                        <div className='overflow-hidden 1.5md:order-last 1.5md:overflow-visible order-first'>
                            <div className='flex justify-center overflow-hidden xl:pe-4 1.5md:overflow-visible'>
                                <img
                                    className='mt-[0.25rem] object-contain h-[13.5rem] sm:mt-[1.5rem] md:mt-0 md:h-[19rem] xl:h-[24rem]'
                                    src={src}
                                    alt=''
                                >
                                </img>
                            </div>
                        </div>
                    </AnimatedComponent>
                </div>
            </div>
        </>
    )
}
